import React from "react";
import "./MainLion.css";

export const MainLion = () => {
    return (
        <div className="mainLionPage">
            <div className="mainLionBackground" />
            <div className="mainLionContent">
                <div className="mainLionText">
                    Messenger-first<br />
                    outreach for<br />
                    gaming brands
                </div>
                <div className="mainLionRow">
                    Run multichannel campaigns across WhatsApp, Telegram, Viber, IMO, KakaoTalk.
                </div>
            </div>
        </div>
    );
};
